import axios from "axios";
import { GUEST_SERVICE_TOKEN } from "store/constants/actions";
import { loadState } from "utils/localStorage";

export const getJwt = () => {
  return loadState(GUEST_SERVICE_TOKEN);
};

const instance = axios.create({
  baseURL: process.env.GATSBY_GUEST_SERVICE,
  headers: {
    "Content-Type": "application/json",
    "ayana-lang": "<lang id|en|ja|zh|ko>",
    "ayana-client-type": "booking-engine-frontend",
    Accept: "application/vnd.ayanamobile.v1+json",
  },
});

instance.interceptors.request.use(
  function (config) {
    const jwt = getJwt();
    if (jwt) {
      config.headers.Authorization = `Bearer ${jwt}`;
    }

    if (config.data) {
      config.data.source = "booking_engine";
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default instance;
